import produce from 'immer';
import {
    FETCH_CUSTOMER,
    FETCH_CUSTOMER_ERROR,
    FETCH_CUSTOMER_SUCCESS,
    RESET_LOGIN_FORM_PASSWORD,
    SET_LOGIN_FORM_DATA,
    UPDATE_CUSTOMER_DATA,
    UPDATE_CUSTOMER_SUBSCRIPTION_PREFERENCES,
    UPDATE_CUSTOMER_SUBSCRIPTION_PREFERENCES_ERROR,
    CUSTOMER_STATUS,
    UPDATE_CUSTOMER_AUTH_STATUS,
} from '../constants';
import { CustomerState } from '../types';

const initialState: CustomerState = {
    data: null,
    status: CUSTOMER_STATUS.LOADING,
    isFetchInProgress: false,
    subscriptionPreferences: {
        data: null,
        error: null,
    },
    forms: {
        login: {
            username: '',
            password: '',
        },
    },
};

export const customer = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case FETCH_CUSTOMER:
            state.isFetchInProgress = true;
            state.status = CUSTOMER_STATUS.LOADING;
            break;

        case FETCH_CUSTOMER_ERROR:
            state.isFetchInProgress = false;
            state.status = CUSTOMER_STATUS.ERROR;
            break;

        case FETCH_CUSTOMER_SUCCESS:
            state.data = payload;
            state.isFetchInProgress = false;
            state.status = CUSTOMER_STATUS.AUTHENTICATED;
            break;

        case SET_LOGIN_FORM_DATA:
            state.forms.login = payload;
            break;

        case RESET_LOGIN_FORM_PASSWORD:
            state.forms.login.password = '';
            break;

        case UPDATE_CUSTOMER_DATA:
            state.data = { ...state.data, ...payload };
            break;

        case UPDATE_CUSTOMER_SUBSCRIPTION_PREFERENCES:
            state.subscriptionPreferences.error = null;
            state.subscriptionPreferences.data = payload;
            break;

        case UPDATE_CUSTOMER_SUBSCRIPTION_PREFERENCES_ERROR:
            state.subscriptionPreferences.error = payload;
            break;

        case UPDATE_CUSTOMER_AUTH_STATUS:
            state.status = payload;
            break;
        // skip default
    }
}, initialState);
